import React, { useState } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography
} from '@material-ui/core';

const CustomAlert = ({ open, message, onClose }: {
  open: boolean;
  message: string;
  onClose: () => void;
}) => (
  <Dialog open={open} onClose={onClose}>
    <DialogTitle disableTypography>
      <Typography variant="h6" style={{ fontSize: '18px' }}>2025好侍紅白洋食對決</Typography>
    </DialogTitle>
    <DialogContent>
      <Typography style={{ fontSize: '16px', whiteSpace: 'pre-line' }}>{message}</Typography>
    </DialogContent>
    <DialogActions style={{ justifyContent: 'center', padding: 16}}>
      <Button onClick={onClose} variant="contained" color="primary" style={{ fontSize: '14px', padding: '6px 16px' }}>
        確定
      </Button>
    </DialogActions>
  </Dialog>
);

export default CustomAlert;
